export default __webpack_public_path__ + "static/cyber-lisa-eba8290a40384244a3f4b3df5d960769.webm";